import { INSTALLMENTS_COUNT_LIST_FOR_DEFAULT_PROMO } from 'src/constants/learn-more';
import { allowedCurrencies } from 'src/types/currency';

import { deriveProductFacts } from './product-facts';
import { type LearnMoreDecision, type WidgetDecisionInput } from './types';

export type PromoDecision = Readonly<{
  surface: 'promo';
  snippet: 'ltf' | 'non-ltf' | 'default';
  learnMore: LearnMoreDecision;
}>;

export const decidePromo = (input: WidgetDecisionInput): PromoDecision => {
  const facts = deriveProductFacts(input);
  const isValidCountry =
    input.formattedCurrency !== undefined &&
    allowedCurrencies.includes(input.formattedCurrency);
  const constructorCount =
    input.installmentsCountRaw || input.installmentsCount;
  const isPixWidget =
    isValidCountry &&
    !facts.shouldShowLongTermContent &&
    INSTALLMENTS_COUNT_LIST_FOR_DEFAULT_PROMO.includes(
      constructorCount as number
    );
  const isNonDefaultWidget = !isPixWidget && !facts.shouldShowLongTermContent;
  const shouldOpenPayLaterLearnMore =
    Boolean(input.offers.monthlyBilling) && !facts.hasInstallments;

  let snippet: PromoDecision['snippet'];
  let learnMore: LearnMoreDecision;

  if (facts.shouldShowLongTermContent) {
    snippet = 'ltf';
    learnMore = 'ltf';
  } else if (isNonDefaultWidget) {
    snippet = 'default';
    learnMore = facts.shouldOpenLongTermLearnMore ? 'ltf' : 'default';
  } else {
    snippet = 'non-ltf';
    learnMore = facts.shouldOpenLongTermLearnMore ? 'ltf' : 'pix';
  }

  if (shouldOpenPayLaterLearnMore) {
    learnMore = 'pix';
  }

  return {
    surface: 'promo',
    snippet,
    learnMore,
  };
};
